// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3JLqb","colBig":"styles_colBig__2K4KR","colSmall":"styles_colSmall__i3r3J"};